import React from "react";

export default function CategoryPills({ categories, active, onSelect }) {
  return (
    <div className="category-pills-row">
      {categories.map((c) => (
        <button
          key={c}
          type="button"
          className={`genre-pill ${active === c ? "active" : ""}`}
          onClick={() => onSelect(c)}
        >
          {c}
        </button>
      ))}
    </div>
  );
}
